export const eventToPos = (event) => ({
    x: event.clientX,
    y: event.clientY,
});
